
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';


const CuisinePage = () => {
    const { cuisineId } = useParams();
    const [cuisine, setCuisine] = useState(null);
    const [recipes, setRecipes] = useState([]);

    useEffect(() => {
        const fetchCuisineData = async () => {
            
        };

        fetchCuisineData();
    }, [cuisineId]);

    return (
        <div>
            {/* {cuisine && (
                <h1>{cuisine.name}</h1>
            )}
            <h2>Related Recipes</h2>
            <ul>
                {recipes.map(recipe => (
                    <li key={recipe.id}>{recipe.title}</li>
                ))}
            </ul> */}
        </div>
    );
};

export default CuisinePage;
